import { render } from "./HostGame.vue?vue&type=template&id=178bafe6&scoped=true"
import script from "./HostGame.vue?vue&type=script&lang=js"
export * from "./HostGame.vue?vue&type=script&lang=js"

import "./HostGame.vue?vue&type=style&index=0&id=178bafe6&scoped=true&lang=css"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\Super Tactico - Official App\\Online - Routed\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178bafe6"]])

export default __exports__